/**
 * The identity hue a mark is drawn in — routed through the THEME.
 *
 * The server derives a colour per account (`colorFor()` in internal/rooms/hub.ts:
 * sha256 of the id, modulo this exact list) and ships it as a hex string. Drawn
 * raw, that hex is frozen at whatever palette the server was built with, and the
 * owner's complaint was exactly that: pick Deep sea and your mark stays Rouge's
 * red until a reload — and after the reload it is STILL Rouge's red, because the
 * server has never heard of themes.
 *
 * So the hex is treated as a SLOT, not a colour. `themedTint()` maps it to the
 * matching `--person-N` custom property (the People block in app.css), which
 * every theme re-keys; `applyTheme()` writes tokens on <html>, so every mark on
 * screen recolours the moment a theme is chosen, live, no reload. The person
 * keeps their slot — the same friend is the same slot in every theme — and the
 * theme keeps its light.
 *
 * PERSON_COLORS must match `COLORS` in internal/rooms/hub.ts slot for slot, and
 * `--person-1..12` in app.css carry these same hexes as their defaults. A hex
 * this list does not know (an old server, a future palette) passes through
 * unchanged — a wrong-but-stable colour beats an invisible mark — and the token
 * reference carries the hex as its fallback for the same reason.
 */
export const PERSON_COLORS: readonly string[] = [
  '#e0575b',
  '#e08a3c',
  '#d7b13a',
  '#7fb03c',
  '#3fae7a',
  '#39a9b8',
  '#4b90e2',
  '#6f6fe0',
  '#a05fd6',
  '#d155a6',
  '#c47a5a',
  '#8a9aa8'
];

/** A CSS colour for the mark: the slot token when the hex is one of the
 *  server's twelve, the value untouched otherwise (`var(--accent)` included). */
export function themedTint(color: string): string {
  const hex = color.trim().toLowerCase();
  const slot = PERSON_COLORS.indexOf(hex);
  return slot === -1 ? color : `var(--person-${slot + 1}, ${hex})`;
}
